import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { FormsModule } from '@angular/forms';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbModalModule, NgbNav, NgbNavItem, } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderRoutingModule } from 'app/shared/utility/utility-routing.module';
import { AddOnOrderService } from './services/add-on-order.service';
import { AuthGuard } from 'app/auth/helpers/auth.guards';
import { AddOnOrderListComponent } from './view/add-on-order-list/add-on-order-list.component';
import { AddOnOrderDetailsComponent } from './view/add-on-order-details/add-on-order-details.component';

const routes = [
  {
    path: 'add-on/order-list/:orderType',
    component: AddOnOrderListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-on/order-details/:orderType/:orderId',
    component: AddOnOrderDetailsComponent,
    canActivate: [AuthGuard]
  }
  
];

@NgModule({
  declarations: [ 
    AddOnOrderListComponent,
    AddOnOrderDetailsComponent,
  ],
  imports: [RouterModule.forChild(routes),
    ContentHeaderModule,
    TranslateModule,
    CoreCommonModule,
    CardSnippetModule,
    FormsModule,
    CoreDirectivesModule,
    NgbRatingModule,
    NgbModule,
    NgbModalModule,
    NgSelectModule,
    LoaderRoutingModule,
  ],
  exports: [
    
  ],
  providers: [AddOnOrderService]
})
export class AddOnOrdersRoutingModule { }
